import React from "react";



export function EditKeywordsContainer({ accessToken, name, email }) {
  return(
      <p>EditKeywords</p>
  )
}
 